import { html } from "lit-html";
import { BallPointPenAction } from "../../../actions/ballpoint_pen/ballpoint_pen_action";
import { each } from "../../../component";
import { BallPointPenJsEnv } from "../../../models/ballpoint_pen/ballpoint_pen_js_env";

export const BallPointPenMakerArea = (ballPointPenJsEnv: BallPointPenJsEnv) => html`
  <div class="a-pulldown js-lazy-img -size48 -full">
    <label class="a-pulldown_label">
      <span class="a-pulldown_labeltxt">メーカー名</span>
      <span class="a-pulldown_select">
        <select
          @change="${(event: Event) => {
            BallPointPenAction.drillDownSeries(getValueFromEvent(event));
          }}">
          ${(ballPointPenJsEnv.ballpointPenMakers.length === 0) ? html``: html`<option value="" .selected="${ballPointPenJsEnv.selectedMaker === ''}">メーカーを選択</option>`}
          ${each(CreateBallPointPenMaker(ballPointPenJsEnv.ballpointPenMakers, ballPointPenJsEnv.selectedMaker), BallPointPenMakers)}
        </select>
      </span>
    </label>
  </div>
`;

const BallPointPenMakers = (ballPointPenMaker: BallPointPenMakerInterface) => html`
<option value="${ballPointPenMaker.ballPointPenMaker}"
  .selected="${ballPointPenMaker.ballPointPenMaker === ballPointPenMaker.selectedMaker}">
  ${ballPointPenMaker.ballPointPenMaker}
</option>
`;

export const BallPointPenSeriesArea = (ballPointPenJsEnv: BallPointPenJsEnv) => html`
<div class="a-pulldown js-lazy-img -size48 -full">
  <label class="a-pulldown_label">
    <span class="a-pulldown_labeltxt">シリーズ名</span>
    <span class="a-pulldown_select">
      <select id="ballpoint-pen-series"
        @change="${(event: Event) => {
          BallPointPenAction.drillDownSizes(ballPointPenJsEnv.selectedMaker, getValueFromEvent(event));
      }}">
        ${(ballPointPenJsEnv.ballPointPenSeries.length === 0) ? html`` : html`<option value="" .selected="${ballPointPenJsEnv.selectedSeries === ''}">シリーズを選択</option>`}
        ${each(CreateBallPointPenSeries(ballPointPenJsEnv.ballPointPenSeries, ballPointPenJsEnv.selectedSeries), BallPointPenSeries)}
      </select>
    </span>
  </label>
</div>
`;

const BallPointPenSeries = (ballPointPenSeries: BallPointPenSeriesInterface) => html`
<option value="${ballPointPenSeries.ballPointPenSeries}"
  .selected="${ballPointPenSeries.ballPointPenSeries === ballPointPenSeries.selectedSeries}">
  ${ballPointPenSeries.ballPointPenSeries}
</option>
`;

export const BallPointPenSizesArea = (ballPointPenJsEnv: BallPointPenJsEnv) => html`
<div class="a-pulldown js-lazy-img -size48 -full">
  <label class="a-pulldown_label">
    <span class="a-pulldown_labeltxt">ボール径（mm）</span>
    <span class="a-pulldown_select">
      <select id="ballpoint-pen-size"
        @change="${(event: Event) => {BallPointPenAction.updateSelectedSize(getValueFromEvent(event))}}">
        ${(ballPointPenJsEnv.ballPointPenSizes.length === 0) ? html`` : html`<option value="" .selected="${ballPointPenJsEnv.selectedSize === ''}">ボール径を選択</option>`}
        ${each(CreateBallPointPenSize(ballPointPenJsEnv.ballPointPenSizes, ballPointPenJsEnv.selectedSize), BallPointPenSizes)}
      </select>
    </span>
  </label>
</div>
`;

const BallPointPenSizes = (ballPointPenSizes: BallPointPenSizesInterface) => html`
<option value="${ballPointPenSizes.ballPointPenSize}"
  .selected="${ballPointPenSizes.ballPointPenSize === ballPointPenSizes.selectedSize}">
  ${ballPointPenSizes.ballPointPenSize}
</option>
`;

const getValueFromEvent = (event: Event) => {
  const { target } = event;

  if(!(target instanceof HTMLSelectElement)) {
    throw 'cannot get value from event.'
  }

  return target.value;
}

const CreateBallPointPenMaker = (ballPointPenMakers: string[], selectedMaker: string) => {
  return ballPointPenMakers.map(maker => {
    let ballPointPenMakerInterface: BallPointPenMakerInterface = {
      ballPointPenMaker: maker,
      selectedMaker: selectedMaker
    };
    return ballPointPenMakerInterface;
  });
}

const CreateBallPointPenSeries = (ballPointPenSeries: string[], selectedSeries: string) => {
  return ballPointPenSeries.map(series => {
    let ballPointPenSeriesInterface: BallPointPenSeriesInterface = {
      ballPointPenSeries: series,
      selectedSeries: selectedSeries
    };
    return ballPointPenSeriesInterface;
  });
}

const CreateBallPointPenSize = (ballPointPenSizes: string[], selectedSize: string) => {
  return ballPointPenSizes.map(size => {
    let ballPointPenSizesInterface: BallPointPenSizesInterface = {
      ballPointPenSize: size,
      selectedSize: selectedSize
    };
    return ballPointPenSizesInterface;
  });
}

interface BallPointPenMakerInterface {
  ballPointPenMaker: string;
  selectedMaker: string;
}

interface BallPointPenSeriesInterface {
  ballPointPenSeries: string;
  selectedSeries: string;
}

interface BallPointPenSizesInterface {
  ballPointPenSize: string;
  selectedSize: string;
}
